// extracted by mini-css-extract-plugin
module.exports = {"addDocs":"myDocumentContainer_addDocs__1UrQK","requiredDocs":"myDocumentContainer_requiredDocs__1EwRm","padding":"myDocumentContainer_padding__dvcBA"};